import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6252b851")

_pushScopeId("data-v-6252b851")
const _hoisted_1 = { class: "karte-result-list" }
const _hoisted_2 = { class: "floating-parts-button" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("プレビュー ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("項目追加 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("戻る ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("削除 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("カルテ保存 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("カルテを保存せずに戻っていいですか？ ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("このカルテを削除してもいいですか？ ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("カルテを保存しますか？ ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_karte_header = _resolveComponent("karte-header")
  const _component_patient_header = _resolveComponent("patient-header")
  const _component_vue_sub_content = _resolveComponent("vue-sub-content")
  const _component_karte_title = _resolveComponent("karte-title")
  const _component_karte_result = _resolveComponent("karte-result")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_vue_button_frame = _resolveComponent("vue-button-frame")
  const _component_confirm = _resolveComponent("confirm")
  const _component_karte_item_modal = _resolveComponent("karte-item-modal")
  const _component_preview = _resolveComponent("preview")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_content_remain, null, {
        default: _withId(() => [
          _createVNode(_component_vue_content, { class: "vue-content-remain-child" }, {
            default: _withId(() => [
              _createVNode(_component_karte_header),
              _createVNode(_component_vue_sub_content, null, {
                default: _withId(() => [
                  _createVNode(_component_patient_header)
                ]),
                _: 1
              }),
              _createVNode(_component_vue_y_scroll_area, null, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode(_component_karte_title),
                    _createVNode(_TransitionGroup, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.order, ({ id, arrayIndex }) => {
                          return (_openBlock(), _createBlock(_component_karte_result, {
                            class: "karte-item",
                            key: id,
                            resultId: id,
                            resultIndex: arrayIndex
                          }, null, 8, ["resultId", "resultIndex"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode("div", _hoisted_2, [
                _createVNode(_component_normal_button, {
                  type: "normal",
                  class: "karte-item-button",
                  state: "normal",
                  onClick: _ctx.onPreview
                }, {
                  default: _withId(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_normal_button, {
                  type: "normal",
                  class: "karte-item-button",
                  state: "normal",
                  onClick: _ctx.onAddKarteItem
                }, {
                  default: _withId(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ], 512), [
                [_vShow, _ctx.delayed]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_vue_button_frame, null, {
        left: _withId(() => [
          _createVNode(_component_normal_button, {
            class: "vue-button-frame-button",
            state: "normal",
            onClick: _ctx.onBack
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        right: _withId(() => [
          (_ctx.patientWrite)
            ? (_openBlock(), _createBlock(_component_normal_button, {
                key: 0,
                class: "vue-button-frame-button",
                state: "delete",
                disabled: _ctx.karteId === '',
                onClick: _ctx.onDelete
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.patientWrite)
            ? (_openBlock(), _createBlock(_component_normal_button, {
                key: 1,
                class: "vue-button-frame-button",
                state: "warning",
                disabled: !_ctx.editing,
                onClick: _ctx.onSave
              }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "confirmBackRef",
        onYes: _ctx.yesBack
      }, {
        default: _withId(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onYes"]),
      _createVNode(_component_confirm, {
        ref: "confirmDeleteRef",
        onYes: _ctx.yesDelete
      }, {
        default: _withId(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["onYes"]),
      _createVNode(_component_confirm, {
        ref: "confirmSaveRef",
        onYes: _ctx.yesSave
      }, {
        default: _withId(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onYes"]),
      _createVNode(_component_karte_item_modal, {
        ref: "karteItemRef",
        onYes: _ctx.yseKarteItem
      }, null, 8, ["onYes"]),
      _createVNode(_component_preview, { ref: "previewRef" }, null, 512)
    ]),
    _: 1
  }))
})